import Initialization from "./index.vue";
import Vue from "vue";
import {
  ContainerMethods,
  ContainerData,
  ContainerComputed,
  ContainerProps,
  OnboardingStatusType
} from "./types";
import { registerOnboarding } from "@/api";
import { ApiRequest } from "@/api/types";
import { RECRUITMENT_NUMBER_OPTIONS } from "@/constants/onboarding";
import {
  getOnboardingSnapShot,
  removeOnboardingSnapShot,
  saveOnboardingSnapShot
} from "@/helpers/onboarding-helper";
import { updateUserWithToken } from "@/helpers/auth-helper";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      loading: false,
      currentStep: 1,
      onboardingStatus: OnboardingStatusType.DONE,
      onboardingData: {
        recruitmentNumber: 0,
        universities: [],
        companies: []
      }
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["domains/user/isLoggedIn"];
    },
    partnerUser() {
      return this.$store.state.domains.user.partnerUser;
    },
    isOnboardingFinished() {
      if (!this.partnerUser) return;
      return this.partnerUser.onboarding_finished;
    },
    isRecruitmentNumberRegistered() {
      if (!this.partnerUser) return;
      return this.partnerUser.partner.recruitment_number_registered;
    },
    onboardingSnapShot() {
      return {
        onboardingData: this.onboardingData,
        currentStep: this.currentStep
      };
    }
  },
  watch: {
    partnerUser() {
      this.checkOnboardingStatus();
    },
    onboardingSnapShot(value) {
      saveOnboardingSnapShot(value);
    }
  },
  mounted() {
    this.restoreOnboardingSnapShot();
    this.checkOnboardingStatus();
  },
  methods: {
    changeCurrentStep(currentStep) {
      this.currentStep = currentStep;
    },
    checkOnboardingStatus() {
      if (!this.partnerUser) return;

      // 代理ログインの場合オンポーディングモーダルは表示しない
      if (this.partnerUser.logged_in_by_proxy) return;

      // NOTE: フラグない場合、誤ってモーダルを表示させないための処理
      if (
        this.isOnboardingFinished === undefined ||
        this.isRecruitmentNumberRegistered === undefined
      ) {
        return;
      }

      if (!this.isOnboardingFinished) {
        if (this.isRecruitmentNumberRegistered) {
          this.onboardingStatus = OnboardingStatusType.DONE_STEP1;
        } else {
          this.onboardingStatus = OnboardingStatusType.NOT_YET;
        }
      }
    },
    async compleatOnboarding() {
      if (!this.partnerUser) return;
      this.loading = true;

      const requestParam: ApiRequest.RegisterOnboarding = {
        min_recruitment_number: this.isRecruitmentNumberRegistered
          ? undefined
          : this.onboardingData.recruitmentNumber,
        max_recruitment_number: this.isRecruitmentNumberRegistered
          ? undefined
          : RECRUITMENT_NUMBER_OPTIONS.find(
              option => option.value === this.onboardingData.recruitmentNumber
            )!.max,
        university_ids: this.onboardingData.universities.map(
          university => university.id
        ),
        company_ids: this.onboardingData.companies.map(company => company.id)
      };

      await registerOnboarding(requestParam);

      const partnerUser = {
        ...this.partnerUser,
        onboarding_finished: true,
        partner: {
          ...this.partnerUser.partner,
          recruitment_number_registered: true
        }
      };
      updateUserWithToken(partnerUser);
      removeOnboardingSnapShot();

      this.onboardingStatus = OnboardingStatusType.DONE;
      this.loading = false;
    },
    changeOnboardingData(onboardingData) {
      this.onboardingData = onboardingData;
    },
    restoreOnboardingSnapShot() {
      const onboardingSnapShot = getOnboardingSnapShot();
      if (onboardingSnapShot) {
        this.changeCurrentStep(onboardingSnapShot.currentStep);
        this.changeOnboardingData(onboardingSnapShot.onboardingData);
      }
    }
  },
  render(createElement) {
    return createElement(Initialization, {
      props: {
        loading: this.loading,
        isShow:
          this.isLoggedIn &&
          this.onboardingStatus !== OnboardingStatusType.DONE,
        currentStep: this.currentStep,
        onboardingStatus: this.onboardingStatus,
        onboardingData: this.onboardingData
      },
      on: {
        changeCurrentStep: this.changeCurrentStep,
        compleatOnboarding: this.compleatOnboarding,
        changeOnboardingData: this.changeOnboardingData
      }
    });
  }
});
